module.exports = __webpack_public_path__ + "static/media/SVG_chat.df82de14.svg";